// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.css - Exact Figma Layout */

.dashboard {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background-color: #FFFFFF;
  overflow: hidden;
}

/* Body - Nav + Content side by side */
.dashboard-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* Content Area - takes remaining space after nav */
.dashboard-content {
  flex: 1;
  overflow-y: auto;
  background-color: #FFFFFF;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,OAAO;EACP,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["/* Dashboard.css - Exact Figma Layout */\n\n.dashboard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100vh;\n  background-color: #FFFFFF;\n  overflow: hidden;\n}\n\n/* Body - Nav + Content side by side */\n.dashboard-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Content Area - takes remaining space after nav */\n.dashboard-content {\n  flex: 1;\n  overflow-y: auto;\n  background-color: #FFFFFF;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
